import styled from '@emotion/styled'
import { Color } from 'shared/enums'

export const StyledErrorMessage = styled.p`
  color: ${Color.Error};
  font-size: 12px;
  line-height: 15px;
`
